import {BasePage, page} from "./BasePage";
import "../css/common.css"
import "./Token.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used

@page("Token")
export class Token extends BasePage {

	protected get data() {
		return {
			title: "TOKEN",
			items: [{
				dir: "left",
				name: "Private Channels",
				// icon: solid("hands-holding-circle"),
				src: require("../../assets/token1.png"),
				desc: `The PokerDAO NFT is also your key to our private Texas Hold‘em Discord – where you’ll be admitted to our gated community channels.`
			}, {
				dir: "middle",
				name: "Events",
				// icon: solid("chalkboard-user"),
				src: require("../../assets/token2.png"),
				desc: `We guarantee that PokerDAO holders will be able to directly participate in large-scale Texas Hold’em events, as our team includes multiple event organizers.
We provide support for all IRL events (in legal regions) that belong to the PokerDAO`
			}, {
				dir: "right",
				name: "DAO",
				// icon: solid("diamond"),
				src: require("../../assets/token3.png"),
				desc: `These NFTs will allow for community access, governance, and a wide variety of perks. They will be the key to unlock membership at PokerDAO's first Texas Hold‘em club.`
			}, {
				dir: "right",
				name: "Token",
				// icon: solid("circle-dollar-to-slot"),
				src: require("../../assets/token4.png"),
				desc: `NFT holders will be airdropped $chips before the platform is built up
Earn higher pot rewards than non-holders in platform table games`
			}]
		};
	}

	protected webContent() {
		// 在这里完善内容
		return <div>
			{/*<div className="title">{this.data.title}</div>*/}
			<div className="content">
				{this.data.items.map(item =>
					<div className={`item ${item.dir}`}>
						{/*<FontAwesomeIcon className="logo" icon={item.icon} />*/}
						<img className="logo" src={item.src}/>
						<div className="text">
							<div className="subtitle">{item.name}</div>
							<div className="introduction" >{item.desc}</div>
						</div>
					</div>
				)}
				{/*<div className="item left">*/}
				{/*	<img className="logo" src={require('../../assets/icon1.png')}/>*/}
				{/*	<div className="text">*/}
				{/*		<div className="subtitle">PREMIUM ACCESS</div>*/}
				{/*		<div className="introduction" >*/}
				{/*			Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem.*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</div>*/}
				{/*<div className="item middle">*/}
				{/*	<img className="logo" src={require('../../assets/icon2.png')}/>*/}
				{/*	<div className="text">*/}
				{/*		<div className="subtitle">PREMIUM ACCESS</div>*/}
				{/*		<div className="introduction" >*/}
				{/*			Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem.*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</div>*/}
				{/*<div className="item right">*/}
				{/*	<img className="logo" src={require('../../assets/icon3.png')}/>*/}
				{/*	<div className="text">*/}
				{/*		<div className="subtitle">TOKEN AIRDROP</div>*/}
				{/*		<div className="introduction" >*/}
				{/*			$CHIPS is an ERC-20 token built on the Ethereum blockchain. It is the primary utility token and the token used when playing in the poker platform.<br/>*/}
				{/*			<br/>*/}
				{/*			Players will be able to use $CHIPS tokens to access exclusive experiences, items, perks, content and more within PokerDAO world. More information:xxxxxx*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</div>*/}
			</div>
		</div>
	}

	protected mobileContent(): JSX.Element {
		return <div>
			{/*<div className="title">{this.data.title}</div>*/}
			<div className="content">
				{this.data.items.map(item =>
					<div className={`item ${item.dir}`}>
						{/*<FontAwesomeIcon className="logo" icon={item.icon} />*/}
						<img className="logo" src={item.src}/>
						<div className="text">
							<div className="subtitle">{item.name}</div>
							<div className="introduction">{item.desc}</div>
						</div>
					</div>
				)}
			</div>
		</div>

	}
}
